import { Fragment } from 'react';
import CheckboxItem from './CheckboxItem/CheckboxItem';
import _ from 'lodash';
import { getLocale, sendGAEvent } from '!/common/helpers';

// hardcoded hack to sort age suitability.
// Will be replaced by sorting on elasticsearch side: see https://vitafit24.atlassian.net/browse/SN-8534
const age_suitability_sorting = {
  'von Geburt an': 0,
  'ab dem 4. Monat': 4,
  '> 4 Monate': 4,
  'nach dem 4. Monat': 5,
  '> 5 Monate': 5,
  'ab dem 5. Monat': 5.5,
  'ab dem 6. Monat': 6,
  '> 6 Monate': 6,
  'nach dem 6. Monat': 7,
  '> 7 Monate': 7,
  'ab dem 7. Monat': 7.5,
  'ab dem 8. Monat': 8,
  '> 8 Monate': 8,
  '> 9 Monate': 9,
  'ab dem 10. Monat': 10,
  '> 10 Monate': 10,
  'ab dem 1. Jahr': 12,
  '> 12 Monate': 12,
  'ab dem 2. Jahr': 24,
  '> 24 Monate': 24
};

const Checkbox = props => {
  const { name, parentIndex, aggs, values, update, title } = props;

  const widgetOptions = createWidgetOption(name, aggs);

  const onChange = ({ target }) => {
    const currentValues = values[name] || [];
    const index = currentValues.indexOf(target.value);

    if (index > -1) {
      update(name, [...currentValues.slice(0, index), ...currentValues.slice(index + 1)]);
      } else {
        update(name, [...currentValues, target.value]);
      }

      const label = `{"value": "${target.value}", "section": "${title}", "state": "${target.checked ? "on" : "off"}"}`;
      sendGAEvent('Search Filter', 'filter switched', label);
    };

  return (
    <Fragment>
      {widgetOptions.length > 0
        ? widgetOptions.map((option, index) => (
          <CheckboxItem
            hidden={index > 9}
            option={option}
            checked={values[name] ? values[name].indexOf(option.value) > -1 : false}
            onChange={onChange}
            key={index}
            name={`f[${parentIndex}][${name}][${index}]`}
          />
        ))
        : getLocale('No Filter Options')}
    </Fragment>
  );
};

function createWidgetOption(name, aggs) {
  const options = aggs[name] || [];
  const widgetOptions = [...options].filter(({ value }) => value !== "");

  if (name === 'age_suitability') {
    widgetOptions.forEach(option => option['sort'] = age_suitability_sorting[option.value]);
    return _.sortBy(widgetOptions, ['sort']);
  } else {
    return widgetOptions;
  }
}

export default Checkbox;
